import { Chart, Accessibility } from "highcharts"
import { HighchartHelper } from './HighchartHelper'

class PieHighchart {
  constructor(chart) {
    Object.assign(this, chart);

    self = this
    new Chart(this.chart, {
      chart: {
        type: 'pie',
        style: {
          fontFamily: null
        },
        margin: 0,
        events: {
          render() {
            if (chart.config?.hideInnerCircle) {
              return
            }

            if (this.customCircle) {
              this.customCircle.destroy();
            }

            const radius = Math.min(this.plotWidth, this.plotHeight) / 2

            this.customCircle = this.renderer
              .circle(
                this.chartWidth / 2,
                this.chartHeight / 2,
                radius * .64
              ).attr({
                style: 'mix-blend-mode: overlay',
                opacity: .3,
                'pointer-events': 'none',
                //fill: 'red'
              }).add().toFront();


          },
          load() {

            const points = this.series[0].points

            for (const [index, toggleBox] of [...self.chartList.querySelectorAll('.visibility-toggle__checkbox, .chart__entry-label')].entries()) {
              const point = points[index]

              toggleBox.addEventListener('change', (e) => {
                point.setVisible(!point.visible)
              })
              
                const label = toggleBox.closest(".chart__entry")
                label.addEventListener('mouseover', (e) => {
                  points.map(e => {
                    e.opacity = point == e ? 1 : 0.33
                    e.update()
                  })
                })
                label.addEventListener('mouseout', (e) => {
                  points.map(e => {
                    e.opacity = 1
                    e.update()
                  })

                })
            }

          },
        }
      },
      title: {
        text: ''
      },
      tooltip: HighchartHelper.tooltipTemplate(),
      accessibility: {
        point: {
          valueSuffix: ' %'
        }
      },
      plotOptions: {
        backgroundColor: null,
        borderWidth: null,
        shadow: false,
        pie: {
          startAngle: -33,
          borderRadius: 0,
          borderWidth: 0,
          padding: 0,
          crisp: true,
          dataLabels: {
            enabled: false
          },
          states: {
            hover: {
              enabled: true,
              halo: false,
              brightness: 0,
              shadow: false,
            },
          },
        }
      },
      series: [{
        innerSize: "58 %",
        colorByPoint: true,
        data: this.config.data
      }],
      credits: {
        enabled: false,
      },
    })
  }
}

export default PieHighchart
